// extracted by css-extract-rspack-plugin
var _1 = "QLvRS2WZLekYIkyx";
export { _1 as "checkboxList" }
